import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div>
      <div className="w-1/2 mx-auto mt-8 space-y-4">
        <h1>Oops...</h1>
        <p>It looks like you have gotten off track.</p>
        <Link to="/" className="text-blue-500 underline">
          Get me back on track
        </Link>
      </div>
    </div>
  );
};

export default ErrorPage;
